<template>
  <section id="calendarWrapper">
    <CalendarMonth />
  </section>
</template>

<script>
import CalendarMonth from '@/components/calendar/CalendarMonth'

export default {
  name: 'CalendarWrapper',
  components: {
    'CalendarMonth': CalendarMonth
  }
}
</script>



// WEBPACK FOOTER //
// src/components/calendar/CalendarWrapper.vue